import React, { useEffect, useState, forwardRef } from "react";
import { Header } from '../../components/Header/Header';
import { Navigator } from '../../components/Navigator/Navigator';
import photo from "../../assets/Profile/Profile-IMG.png";
import { api } from "../../context/Auth";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { set, useForm } from "react-hook-form";
import visibleIcon from "../../assets/Home/visible.svg";
import noVisibleIcon from "../../assets/Home/not-visible.svg";
import Swal from "sweetalert2";
import axios from "axios";
import { ModalAddPP } from "../../components/ModalAddPP";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

function AccessKey() {


    const {
        enterprise,
        loading,
        user,
        updateProfileEnterprise,
        getProfileAcknowledge,
        updateNemuProfile,
      } = useAuth(); // Obtén la función de registro desde el contexto
      let userid;
      const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
        setValue,
      } = useForm();

      const [visibleCurrent, setVisibleCurrent] = useState(false);
      const [visibleNew, setVisibleNew] = useState(false);
      const [text1, setText1] = useState(""); // Estado para el primer texto (límite 400)
      const [preview, setPreview] = useState(photo);
      const [userId, setUserId] = useState(userid);
      const [openModalPP, setOpenModalPP] = useState(false);
      const [openModal, setOpenModal] = useState(false);
      const [coverPage, setCoverPage] = useState(null);
      const [profile_picture, setProfilePicture] = useState(null);
      const [acknowledge, setAcknowledge] = useState(null);
      const closeModal = () => {
        setOpenModal(false);
      };
    
       // Función para abrir el modal
       const openModalPPHandler = () => {
        setOpenModalPP(true);
      };
    
      // Función para cerrar el modal
      const closeModalPPHandler = () => {
        setOpenModalPP(false);
      };
    
    
      const handleChange1 = (e) => {
        if (e.target.value.length <= 400) {
          setText1(e.target.value);
        }
      };
    
      const fetchProfileAcknowledge = async (id) => {
        try {
          const response = await getProfileAcknowledge(id);
          console.log(response.data);
          setAcknowledge(response.data);
        } catch (error) {
          console.error("Error al obtener el perfil de la empresa:", error);
        }
      };
    
      useEffect(() => {
        // console.log(loading);
        // console.log(enterprise);
        if (enterprise) {
          // console.log("Enterprise");
          // console.log(enterprise);
          // console.log("User");
          // console.log(user);
          // console.log("User ID");
          userid = user.id;
          setUserId(userid);
          //console.log(userid);
          //  console.log("Cover Page");
          if (enterprise.profile_picture) {
            setPreview(api + "/" + enterprise.profile_picture);
          } else {
            setPreview(photo);
          }
    
          if (enterprise.profile.cover_page) {
            setCoverPage(api + "/" + enterprise.profile.cover_page);
          } else {
            setCoverPage(photo);
          }
    
          console.log(coverPage);
          setValue("descripcion", enterprise.profile.descripcion); // Establece el valor inicial
          fetchProfileAcknowledge(user.id);
        }
      }, [enterprise, setValue]);
    
      const handleImageChange = async (e) => {
        const file = e.target.files[0];
    
        if (file) {
          // Mostrar preview
          const reader = new FileReader();
          reader.onloadend = () => {
            setPreview(reader.result);
          };
          reader.readAsDataURL(file);
    
          // Preparar y enviar la imagen
          try {
            const formData = new FormData();
            formData.append("image", file);
    
            const response = await axios.patch(
              `${api}/user/update-picture/${user.id}`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );
    
            if (response.data.success) {
              Swal.fire({
                icon: "success",
                title: "¡Imagen actualizada!",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          } catch (error) {
            console.error("Error al actualizar la imagen:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "No se pudo actualizar la imagen",
              showConfirmButton: true,
            });
          }
        }
      };
    
    return (
    <div>
        <main className="w-[100vw] max-w-[100vw] bg-[#eaeaea]">
            <Header />
            <div className="flex h-full w-full pr-[20px] pb-[20px] ">
                <Navigator />
                <div className="grid grid-cols-[1fr_3fr] w-full gap-[10px]">
                    <div className="flex flex-col gap-[2px] ">
                        <div className="w-full bg-white p-[8px] max-h-[calc(100svh-120px)] overflow-y-auto rounded-[4px] ">
                            <div className="flex flex-col gap-[10px] ">
                                {enterprise?.profile.profile_picture ? (
                                <div className="relative group">
                                <img
                                    className="w-full"
                                    src={coverPage}
                                    alt="photo_profile"
                                />
                                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity">
                                    <label className="cursor-pointer p-2 rounded-full bg-white hover:bg-gray-100">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-6 text-gray-600"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                                        />
                                        <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                                        />
                                    </svg>
                                    <input
                                        type="file"
                                        className="hidden"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                    />
                                    </label>
                                </div>
                                </div>
                                ) : (
                                    <div className="relative group">
                                        <img
                                            className="w-full hover:opacity-80 transition-opacity"
                                            src={preview || photo}
                                            alt="photo_profile"
                                        />

                                        {/* Overlay con ícono de cámara al hover */}
                                        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity">
                                            <label className="cursor-pointer p-2 rounded-full bg-white hover:bg-gray-100">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-6 w-6 text-gray-600"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
                                                />
                                                <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
                                                />
                                            </svg>
                                            <input
                                                type="file"
                                                className="hidden"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                            />
                                            </label>
                                        </div>
                                    </div>
                                )}
                                <div className="flex flex-col gap-[4px] ">
                                    <h1 className="text-[24px] ">
                                    {enterprise.enterprise.name}
                                    </h1>
                                    <span className="text-[12px]">
                                    {enterprise.enterprise.address}
                                    </span>
                                </div>
                                </div>
                            </div>
                            <div className="flex w-full bg-white justify-between px-[16px] py-[12px] h-min rounded-[4px] ">
                                <h1 className="text-[20px] ">Número de proyectos</h1>
                                <h1 className="text-[20px]">12</h1>
                            </div>
                            <div className="flex flex-col w-full bg-white justify-between px-[16px] py-[12px] h-min rounded-[4px] ">
                                <span className="text-[12px]">Miembro de Nemu desde</span>
                                {new Date(enterprise.createdAt).toLocaleDateString()}
                            </div>
                    </div>
                    <div className="flex flex-col w-full max-h-[calc(100svh-120px)] overflow-y-auto py-8 px-6 bg-white rounded-[4px] gap-1 ">
                        <h1 className="text-[24px] font-[400]">Cambiar clave de acceso</h1>
                        <hr className="border-t-1 border-nemu-plata" />
                        <div className="flex flex-col w-full space-y-4 mx-auto">
                          <Formik
                            initialValues={{
                              currentPassword: "",
                              newPassword: "",
                            }}
                            validationSchema={Yup.object({
                              currentPassword: Yup.string().required("Contraseña actual requerida"),
                              newPassword: Yup.string()
                                .min(6, "Mínimo 6 caracteres")
                                .required("Nueva contraseña requerida"),
                            })}
                            onSubmit={async (values, { setSubmitting, setStatus }) => {
                              try {
                                const token = localStorage.getItem("token"); // o desde contexto

                                const res = await axios.patch(
                                  `${process.env.REACT_APP_API_URL}/access/change`, // Ajusta a tu ruta real
                                  {
                                    currentPassword: values.currentPassword,
                                    newPassword: values.newPassword,
                                  },
                                  {
                                    headers: {
                                      Authorization: `Bearer ${token}`,
                                    },
                                  }
                                );

                                setStatus({ success: "Contraseña actualizada correctamente." });
                              } catch (error) {
                                const errorMsg = error.response?.data?.message || "Error al actualizar contraseña.";
                                setStatus({ error: errorMsg });
                              } finally {
                                setSubmitting(false);
                              }
                            }}
                          >
                            {({ isSubmitting, status }) => (
                              <Form>
                                <div className="flex flex-col justify-between gap-2 mb-4">
                                    <p className="text-[20px] font-[500]">Clave actual</p>
                                    <span>Ingresa la clave actual</span>
                                    <div className="flex items-center">
                                      <Field type={visibleCurrent ? "text" : "password"} name="currentPassword" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-black focus:outline-none focus:ring focus:ring-grey" />
                                      <img src={visibleCurrent ? visibleIcon : noVisibleIcon} className="-ml-10 w-6 cursor-pointer" alt="Toggle visibility" onClick={() => setVisibleCurrent(!visibleCurrent)} />
                                    </div>
                                    <ErrorMessage name="currentPassword" component="div" />
                                </div>
                                <div className="flex flex-col justify-between gap-2 mb-4">
                                    <p className="text-[20px] font-[500]">Nueva clave</p>
                                    <span>Ingresa la clave nueva</span>
                                    <div className="flex items-center">
                                      <Field type={visibleNew ? "text" : "password"} name="newPassword" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-black focus:outline-none focus:ring focus:ring-grey" />
                                      <img src={visibleNew ? visibleIcon : noVisibleIcon} className="-ml-10 w-6 cursor-pointer" alt="Toggle visibility" onClick={() => setVisibleNew(!visibleNew)} />
                                    </div>
                                    <ErrorMessage name="newPassword" component="div" />
                                </div>

                                <button type="submit" disabled={isSubmitting} className="text-white cursor-pointer bg-[#4C63ED] rounded-[4px] py-2 px-4 mb-4">
                                  Cambiar Contraseña
                                </button>

                                {status?.success && <p style={{ color: "green" }}>{status.success}</p>}
                                {status?.error && <p style={{ color: "red" }}>{status.error}</p>}
                              </Form>
                            )}
                          </Formik>
                        </div>
                    </div>
                </div>    
            </div>
        </main>
    </div>
    );
};

export { AccessKey }